// 连接地址
const restUrl = "http://right.cspaxy.com";
//const restUrl = "http://127.0.0.1:8083";
//const restUrl = "http://10.1.88.59:81";
export default {
    restUrl
};
